import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { Storage } from "@faire/web--source/common/Storage";
var SSO_REQUEST_DATA_KEY = "SSO_REQUEST_DATA_KEY";
export var ssoCache = {
    save: saveSSORequest,
    update: updateSSORequest,
    clear: clearSSORequest,
    get: getSSORequest
};
function updateSSORequest(data) {
    var sessionData = getSSORequest();
    Storage.session.setItem(SSO_REQUEST_DATA_KEY, JSON.stringify(_object_spread({}, sessionData, data)));
}
function saveSSORequest(data) {
    Storage.session.setItem(SSO_REQUEST_DATA_KEY, JSON.stringify(data));
}
function clearSSORequest() {
    Storage.session.removeItem(SSO_REQUEST_DATA_KEY);
}
function getSSORequest() {
    var data = Storage.session.getItem(SSO_REQUEST_DATA_KEY);
    if (data) {
        try {
            return JSON.parse(data);
        } catch (e) {
            return;
        }
    }
    return;
}
